import React from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import { ArrowBack, DashboardOutlined } from "@mui/icons-material";
import { Link, useNavigate } from "react-router-dom";

export default function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        textAlign: "center",
        py: { xs: 8, md: 13 },
        maxWidth: 520,
        mx: "auto",
      }}
    >
      <Typography
        sx={{
          fontSize: 12,
          fontWeight: 700,
          letterSpacing: ".12em",
          color: "primary.main",
          mb: 2,
        }}
      >
        ERRORE 404
      </Typography>
      <Typography component="h1" variant="h4" sx={{ mb: 1.5 }}>
        Questa pagina non è disponibile
      </Typography>
      <Typography color="text.secondary">
        Il collegamento potrebbe essere cambiato. Puoi tornare alla panoramica
        oppure usare la ricerca per trovare la sezione che ti serve.
      </Typography>
      <Stack
        direction="row"
        spacing={2}
        justifyContent="center"
        flexWrap="wrap"
        useFlexGap
        sx={{ mt: 4 }}
      >
        <Button startIcon={<ArrowBack />} onClick={() => navigate(-1)}>
          Indietro
        </Button>
        <Button
          component={Link}
          to="/dashboard"
          variant="contained"
          startIcon={<DashboardOutlined />}
        >
          Vai alla panoramica
        </Button>
      </Stack>
    </Box>
  );
}
